import "../Scss/style.scss";
// @ts-ignore
import AOS from "aos";
import { defineAsyncComponent } from 'vue';
import { Component } from '@vue/runtime-core';
import { createI18n } from 'vue-i18n';

import createApp, { VueDsCookies } from "@digitalwerk/frontend-muster";
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Collapse } from 'bootstrap';
import elementClosest from 'element-closest';

elementClosest(window);

const AjaxForm = defineAsyncComponent(() => import('./Components/AjaxForm.vue'));
const NewsList = defineAsyncComponent(() => import('./../../../../dw_page_types/Resources/Private/Vue/News/List.vue'));
const JobsList = defineAsyncComponent(() => import('./../../../../dw_page_types/Resources/Private/Vue/Jobs/List.vue'));
const JobsFilter = defineAsyncComponent(() => import('./../../../../dw_page_types/Resources/Private/Vue/Jobs/Filter.vue'));
const JobAlertButton = defineAsyncComponent(() => import('./../../../../dw_page_types/Resources/Private/Vue/Jobs/AlertButton.vue'));
const ProductsList = defineAsyncComponent(() => import('./../../../../dw_page_types/Resources/Private/Vue/Products/List.vue'));
const ProductSlider = defineAsyncComponent(() => import('./../../../../dw_page_types/Resources/Private/Vue/Products/Slider.vue'));
const JobHeroSlider = defineAsyncComponent(() => import('./Components/JobHeroSlider.vue'));
const LocationList = defineAsyncComponent(() => import('./Components/LocationList.vue'));
const ContactList = defineAsyncComponent(() => import('./Components/Contact/List.vue'));
const EventList = defineAsyncComponent(() => import('./Components/Event/List.vue'));
const StatsItem = defineAsyncComponent(() => import('./Components/StatsItem.vue'));
const Timeline = defineAsyncComponent(() => import('./Components/Timeline.vue'));
const SocialShare = defineAsyncComponent(() => import('./Components/SocialShare.vue'));
const SolrSearchResults = defineAsyncComponent(() => import('./Components/SolrSearchResults.vue'));
const Disclaimer = defineAsyncComponent(() => import('./Components/Disclaimer.vue'));
const ElTabs = defineAsyncComponent(() => import('element-plus/lib/components/tabs'));
import {ElCollapse, ElCollapseItem, ElTabPane} from "element-plus";
import VueSocialSharing from 'vue-social-sharing'
import DownloadListFilterDirective from './Directives/DownloadListFilter';
import PageHeader from './Components/PageHeader.vue';
import TeasersSlider from './Components/TeasersSlider.vue';
import { VueSolr } from "./plugins";

import localeDe from './locales/de.json';
import localeEn from './locales/en.json';

const PREVENT_UNLOAD_CLASSES = [
    '.ajax',
    '.download',
    '#scroll-to-top',
    '[data-photoswipe]',
    '[download]',
    '[href^=\\#]',
    '[href*=ajax]',
    '[href^=javascript]',
    '[href^=mailto]',
    '[href^=tel]',
    '[href*=tx_typoscriptrendering]',
    '[target^=_blank]',
    '[role^=button]',
];
const SCROLL_OFFSET = 140;

const projectRootComponent: Component = {
    components: {
        JobHeroSlider,
        LocationList,
        ContactList,
        EventList,
        StatsItem,
        Timeline,
        TeasersSlider,
        ElTabs,
        ElTabPane,
        ElCollapse,
        ElCollapseItem,
        'page-header': PageHeader,
        'ajax-form': AjaxForm,
        'news-list': NewsList,
        'products-list': ProductsList,
        'product-slider': ProductSlider,
        JobsList,
        JobsFilter,
        JobAlertButton,
        SocialShare,
        Swiper,
        SwiperSlide,
        SolrSearchResults,
        Disclaimer
    },
    inject: ['solr'],
    computed: {
        scrollOffset() {
            let offset = -SCROLL_OFFSET;

            if (this.header && this.header.value) {
                offset -= this.header.value.offsetHeight;
            }

            return offset;
        }
    },
    methods: {
        mountedHook() {
            document.querySelectorAll('.collapse').forEach((item) => {
                return new Collapse(item);
            })
            const resizeObserver = new ResizeObserver(entries => {
                AOS.refresh();
            })

            resizeObserver.observe(document.body)
        },
        /* ======= GENERAL METHODS ======= */
        initUnload() {
            let links = 'a';

            PREVENT_UNLOAD_CLASSES.forEach((className) => {
                links += `:not(${className})`;
            });

            document.querySelectorAll<HTMLAnchorElement>(links).forEach((link) => {
                link.addEventListener('click', (event) => {
                    const target = event.currentTarget as HTMLAnchorElement | null;

                    if (event.ctrlKey || event.shiftKey || event.metaKey || event.button === 1) {
                        return true;
                    } else if (target?.pathname === window.location.pathname) {
                        return true;
                    } else if (target?.getAttribute('id') === 'history-back') {
                        event.preventDefault();
                        if (window.history.length > 1) {
                            window.history.back();
                        }

                        return false;
                    }
                    document.body.classList.remove('loaded');
                    document.body.classList.add('unloading');

                    return true;
                });
            });
        },
    },
    watch: {
        solr: {
            handler: (newValue, oldValue) => {
                document.body.classList.toggle('search-overlay-opened');
            },
            deep: true
        }
    }
};

// @ts-ignore
const app = createApp(projectRootComponent);

const i18n = createI18n({
    locale: document.querySelector('html')!.lang, // set locale
    fallbackLocale: 'en-US', // set fallback locale
    messages: {
        'en-US': localeEn,
        'de-DE': localeDe,
    },
});

app.directive('download-list-filter', DownloadListFilterDirective);
app.use(i18n);
app.use(VueDsCookies, {
    categories: ['functional', 'analytical', 'socialmedia']
});
app.use(VueSocialSharing);
app.use(VueSolr);

app.mount('#page');


//app.config.compilerOptions.delimiters = ['<%', '%>'];
// @ts-ignore
app.config.devtools = true;
